import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { DashboardLayout } from '../../Components/Layout/DashboardLayout'
import Loader from '../../Components/Loader'
import { useGetNeighborhoodByIdQuery } from '../../Redux/Apis/Neighborhood'

const renderFeatureValue = (enabled) => (
  <span className={`badge bg-${enabled ? 'success' : 'secondary'}`}>
    {enabled ? 'Enabled' : 'Disabled'}
  </span>
)

const NeighborhoodDetails = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const { data, isLoading } = useGetNeighborhoodByIdQuery(id)

  const neighborhood = data?.data

  return (
    <DashboardLayout>
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-12">
            <div className="dashCard">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h2 className="mainTitle mb-1">Neighborhood Details</h2>
                  <p className="text-muted mb-0">Review the live neighborhood configuration for launch.</p>
                </div>
                <button className="btn btn-outline-secondary" onClick={() => navigate('/neighborhoods')}>
                  Back
                </button>
              </div>

              {isLoading ? (
                <Loader />
              ) : !neighborhood ? (
                <div className="alert alert-warning mb-0">Neighborhood not found.</div>
              ) : (
                <div className="row g-4">
                  <div className="col-lg-6">
                    <div className="border rounded p-3 h-100">
                      <h5 className="mb-3">Identity</h5>
                      <p><strong>Display Name:</strong> {neighborhood.displayName || 'N/A'}</p>
                      <p><strong>Slug:</strong> {neighborhood.slug || 'N/A'}</p>
                      <p><strong>Domain:</strong> {neighborhood.domain || 'N/A'}</p>
                      <p><strong>API URL:</strong> {neighborhood.apiUrl || 'N/A'}</p>
                      <p className="mb-0">
                        <strong>Status:</strong>{' '}
                        <span className={`badge bg-${neighborhood.status === 'active' ? 'success' : neighborhood.status === 'maintenance' ? 'warning text-dark' : 'danger'}`}>
                          {neighborhood.status}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="border rounded p-3 h-100">
                      <h5 className="mb-3">Feature Flags</h5>
                      <div className="d-flex justify-content-between mb-2">
                        <span>Forums</span>
                        {renderFeatureValue(neighborhood.features?.enableForums)}
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>Directions</span>
                        {renderFeatureValue(neighborhood.features?.enableDirections)}
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span>Child Tracking</span>
                        {renderFeatureValue(neighborhood.features?.enableChildTracking)}
                      </div>
                      <div className="d-flex justify-content-between mb-0">
                        <span>Push Notifications</span>
                        {renderFeatureValue(neighborhood.features?.enablePushNotifications)}
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="border rounded p-3">
                      <h5 className="mb-3">Launch Sections</h5>
                      {neighborhood.features?.sections?.length ? (
                        <div className="d-flex flex-wrap gap-2">
                          {neighborhood.features.sections.map((section) => (
                            <span key={section} className="badge bg-primary">
                              {section}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted mb-0">No sections configured.</p>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}

export default NeighborhoodDetails
